import Axios from "axios";
import ActivityCard, { ClickableActivityContent, DefaultActivityContent } from "components/ActivityPanel/ActivityCard";
import { ButtonSecondary } from "components/Atoms/Button";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";
import { downloadFile } from "utilities/apiUtils";

interface Props {
  currentFileId: string
  setCurrentFileId: (fileId: string) => void
  activity: server.dto.WordTemplateActivity
}

export const WordTemplateActivityCard = (props: Props) => {
  const [isRestoring, setIsRestoring] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const { activity } = props;
  const { timestampUtc, action } = activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  const isFileUpload = ["uploadedNewFile", "created"].includes(action.value);
  const canRestore = isFileUpload && activity.fileId !== props.currentFileId;

  const title = action.text;
  const subtitles = [`${timstampUtcMoment.fromNow()}`];

  const onDownload = async () => {
    const params = {
      activityId: activity.activityId,
      fileName: activity.content,
    }

    const fileBlobRes = await Axios.post(
      window.CoreApi.WordTemplate.DownloadFileFromActivity.absoluteUrl(),
      params,
      {
        responseType: "blob",
        withCredentials: true
      });
    downloadFile(fileBlobRes.data, activity.content);
  }

  const onRestore = async () => {
    setIsRestoring(true);
    const response = await window.CoreApi.WordTemplate.RestoreFileFromActivity(activity.activityId);
    setIsRestoring(false);
    if (response.data.hasErrors) {
      setError(response.data.errors[0].message);
      return;
    }

    setError(null);
    props.setCurrentFileId(activity.fileId);
  }

  return <ActivityCard
    error={error}
    button={canRestore ? <ButtonSecondary
      loading={isRestoring}
      label={RESX.Buttons.Restore}
      onClick={onRestore}
    /> : null}
    activity={activity}
    getTitle={() => title}
    getSubtitle={() => subtitles}
    getSubtitleHover={() => formatWrittenDateTimeUtc(timstampUtcMoment)}
  >
    {!isFileUpload && <DefaultActivityContent activity={props.activity} />}
    {isFileUpload && <ClickableActivityContent
      value={activity.content}
      onClick={onDownload}
    />}
  </ActivityCard>
}